import { printersTypes } from "./printersTypes"
import { idGenerator } from "helpers/createId"

const {
  GET_PRINTERS,
  NEW_PRINTER,
  EDIT_PRINTER,
  DELETE_PRINTER,

  ADD_PRINT_QUEUE,
  PRINTING_LOADING_START,
  PRINTING_LOADING_STOP,
  RESTORE_PRINT
} = printersTypes

const initialState = {
  printers: [],
  printQueue: [],
  printedQueue: [],
}

export const statusPrinting = {
  ON_HOLD: {
    status: 'ON_HOLD',
    label: 'En Espera'
  },
  PRINTING: {
    status: 'PRINTING',
    label: 'Enviando...'
  },
  PRINTED: {
    status: 'PRINTED',
    label: 'Enviado'
  },
  ERROR: {
    status: 'ERROR',
    label: 'Error con la URL'
  },
  CANCELED: {
    status: 'CANCELED',
    label: 'Cancelado'
  }
}
export const printersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PRINTERS:
      const nPayload = payload.map(printer => ({ ...printer, label: `${printer.name} - [${printer.ip}]`, value: printer.id }))
      return {
        ...state,
        printers: nPayload,
      }
    case NEW_PRINTER:
      const newPayload = { ...payload, label: `${payload.name} - [${payload.ip}]`, value: payload.id }
      return {
        ...state,
        printers: [newPayload, ...state.printers],
      }
    case EDIT_PRINTER:
      let editPrinters = [...state.printers]
      const idx = editPrinters.findIndex(printer => printer.id === payload.id)
      if (idx < 0) return state
      const editPayload = { ...payload, label: `${payload.name} - [${payload.ip}]`, value: payload.id }
      editPrinters[idx] = { ...editPrinters[idx], ...editPayload }
      return {
        ...state,
        printers: editPrinters
      }
    case DELETE_PRINTER:
      return {
        ...state,
        printers: state.printers.filter(printer => printer.id !== payload)
      }

    case ADD_PRINT_QUEUE:

      const inQueue = {
        id: idGenerator(),
        url: payload.url,
        printing: false,
        printLabel: statusPrinting.ON_HOLD.label,
        fileName: payload.fileName,
        status: statusPrinting.ON_HOLD.status
      };

      return {
        ...state,
        printQueue: [...state.printQueue, inQueue],
      };


    case PRINTING_LOADING_START:
      let printQueue = [...state.printQueue]
      const idxP = printQueue.findIndex(printer => printer.id === payload)
      if (idxP < 0) return state
      printQueue[idxP] = {
        ...printQueue[idxP],
        printing: true,
        printLabel: statusPrinting.PRINTING.label,
        status: statusPrinting.PRINTING.status
      }
      return {
        ...state,
        printQueue: printQueue
      }

    case PRINTING_LOADING_STOP:
      let printQueueRemove = [...state.printQueue]
      let printedQueue = [...state.printedQueue]
      const idxS = printQueueRemove.findIndex(printer => printer.id === payload.id)
      if (idxS < 0) return state
      let updatedItem = { ...printQueueRemove[idxS], printing: false }
      if (payload.error === statusPrinting.CANCELED.status) {
        updatedItem.printLabel = statusPrinting.CANCELED.label
        updatedItem.status = statusPrinting.CANCELED.status
      } else if(payload.error === statusPrinting.ERROR.status) {
        updatedItem.printLabel = statusPrinting.ERROR.label
        updatedItem.status = statusPrinting.ERROR.status
      } else {
        updatedItem.printLabel = statusPrinting.PRINTED.label
        updatedItem.status = statusPrinting.PRINTED.status
      }
      printedQueue.push(updatedItem)
      return {
        ...state,
        printQueue: printQueueRemove.filter(printer => printer.id !== payload.id),
        printedQueue: printedQueue,
      }
    case RESTORE_PRINT:
      return initialState
    default: return state
  }
}